import requestApi from '@/common/http.js'

class Logout {
  /**
   * 通行证登录
   *
   * @param {Object} data   登录参数
   */
  add() {
    // 定义接口地址
    const url = '/logout'

    const data = {}

    // 对参数进行验证后请求接口
    return requestApi({
      url,
      method: 'post',
      data
    })
  }
}

export default new Logout()
